import { OpportunityView } from '@api-proxies';
import { TabNames } from '@models/enums/TabNames';
import { formatCurrencyUSD, formatPercentageDisplay } from '@shared/grids/grid-formatters.config';
import { formatDateTimeDisplay } from '@utils/date-utils';
import { ColDef, ICellRendererParams } from 'ag-grid-enterprise';

type DashboardOpportunitiesGrid = 'newProjects' | 'upcomingBids';

const nameColumnDef: ColDef<OpportunityView> = {
    colId: 'name',
    field: 'name',
    headerName: 'Name',
    cellDataType: 'text',
    cellRenderer: (params: ICellRendererParams<OpportunityView>) => {
        const id = params.data?.id;
        const name = params.value;

        return id && name
            ? `<a class="anchor" href="/opportunities-single/${id}/${TabNames[TabNames.Overview]}">${name}</a>`
            : '';
    }
};

const financialColumnDefs: ColDef<OpportunityView>[] = [
    {
        colId: 'potentialValue',
        field: 'potentialValue',
        headerName: 'Potential Value',
        valueFormatter: (params) => formatCurrencyUSD(params.value)
    },
    {
        colId: 'proposedGrossMarginPercentage',
        field: 'proposedGrossMarginPercentage',
        headerName: 'Potential GM',
        valueFormatter: (params) => formatPercentageDisplay(params.value)
    },
    {
        colId: 'actualValue',
        field: 'actualValue',
        headerName: 'Actual Value',
        valueFormatter: (params) => formatCurrencyUSD(params.value)
    },
    {
        colId: 'actualGrossMarginPercentage',
        field: 'actualGrossMarginPercentage',
        headerName: 'Actual GM',
        valueFormatter: (params) => formatPercentageDisplay(params.value)
    }
];

export function createDashboardOpportunitiesGridColumnDefs(
    type: DashboardOpportunitiesGrid
): ColDef<OpportunityView>[] {
    const typeColumnDefs: ColDef<OpportunityView>[] =
        type === 'newProjects'
            ? [
                  { colId: 'probabilityName', field: 'probabilityName', headerName: 'Probability' },
                  { colId: 'leadSourceName', field: 'leadSourceName', headerName: 'Lead Source' }
              ]
            : [
                  {
                      colId: 'dueDate',
                      field: 'dueDate',
                      headerName: 'Due Date',
                      valueFormatter: (params) => formatDateTimeDisplay(params.value)
                  },
                  { colId: 'companyName', field: 'companyName', headerName: 'Customer', type: 'textWithTooltip' }
              ];

    return [nameColumnDef, ...typeColumnDefs, ...financialColumnDefs];
}
